module.exports = __webpack_public_path__ + "img/caselist8.74060095.jpg";